import { DEFAULT_TOTAL_RECORDS } from "utils/constants";
import zoneLocalStorageId from "utils/zone";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchFranchise = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );
  const selectedKeyword = filter?.keyword;
  const isFranchiseIdSearch = selectedKeyword === "franchise_id";
  const rawSearchText = String(filter?.text ?? "").trim();

  let params = {
    limit,
    page_no,
    zone_id: zoneLocalStorageId(),
    ...filter,
  };

  if (isFranchiseIdSearch) {
    const { keyword, text, ...remainingFilters } = filter || {};
    params = {
      limit,
      page_no,
      zone_id: zoneLocalStorageId(),
      ...remainingFilters,
    };

    if (rawSearchText !== "") {
      const parsedFranchiseId = Number(rawSearchText);
      if (Number.isFinite(parsedFranchiseId)) {
        params.franchise_id = parsedFranchiseId;
      }
    }
  }

  if (f_is_franchise_employee === 1) {
    params = {
      ...params,
      f_is_franchise_employee,
      f_franchise_id,
      f_is_super_franchise,
    };
  }
  return axiosInstance.get(EndPoints.Franchise.LIST, {
    params,
  });
};

export const fetchChildFranchise = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );

  let { is_active, list_all_child_franchise, franchise_id } = filter;

  let params = {
    limit: 0,
    // page_no,
    zone_id: zoneLocalStorageId(),
    is_active,
    list_all_child_franchise,
    franchise_id,
  };

  if (f_is_franchise_employee === 1) {
    params = {
      ...params,
      f_is_franchise_employee,
      f_franchise_id,
      f_is_super_franchise,
    };
  }
  return axiosInstance.get(EndPoints.Franchise.LIST, {
    params,
  });
};

export const createFranchise = (payload) => {
  return axiosInstance.post(EndPoints.Franchise.CREATE, payload);
};

export const updateFranchise = (payload) => {
  return axiosInstance.put(EndPoints.Franchise.UPDATE, payload);
};

export const deleteFranchise = (payload) => {
  const url = EndPoints.Franchise.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const fetchFranchiseUsername = (payload) => {
  return axiosInstance.get(EndPoints.Franchise.EXISTS_USERNAME, {
    params: {
      ...payload,
      zone_id,
    },
  });
};

export const fetchFranchiseById = (id) => {
  return axiosInstance.get(`${EndPoints.Franchise.LIST_BY_ID}/${id}`);
};

export const downloadFranchiseCSV = () => {
  return axiosInstance.put(EndPoints.Franchise.DOWNLOAD_CSV, {
    responseType: "blob",
  });
};

export const allotBarcodes = (payload) => {
  const { franchiseId, barcodeNumber } = payload;
  return axiosInstance.post(
    EndPoints.Franchise.ALLOT_BARCODE,
    {},
    {
      params: {
        franchise_id: franchiseId,
        num_barcode: barcodeNumber,
      },
    }
  );
};

export const fetchFranchiseListWithStatistics = (filter) => {
  const payload = {
    date_from: filter.date_from,
    date_to: filter.date_to,
  };

  if (filter.zone_id && filter.zone_id !== "All") {
    payload.zone_id = filter.zone_id;
  }

  if (
    filter.zone_id === "All" &&
    Array.isArray(filter.zone_ids) &&
    filter.zone_ids.length > 0
  ) {
    payload.zone_ids = filter.zone_ids;
  }

  if (filter.marketing_person) {
    payload.marketing_person = filter.marketing_person;
  }

  return axiosInstance.post(EndPoints.Franchise.LIST_WITH_STATISTICS, payload);
};

export const fetchZoneListWithStatistics = (filter) => {
  const payload = {
    date_from: filter.date_from,
    date_to: filter.date_to,
  };

  if (filter.zone_id && filter.zone_id !== "All") {
    payload.zone_id = filter.zone_id;
  }

  if (
    filter.zone_id === "All" &&
    Array.isArray(filter.zone_ids) &&
    filter.zone_ids.length > 0
  ) {
    payload.zone_ids = filter.zone_ids;
  }

  if (filter.marketing_person) {
    payload.marketing_person = filter.marketing_person;
  }

  return axiosInstance.post(
    EndPoints.Franchise.ZONE_LIST_WITH_STATISTICS,
    payload
  );
};

export const fetchFranchiseStatisticsMarketingPersons = (filter) => {
  const payload = {};

  if (filter.zone_id && filter.zone_id !== "All") {
    payload.zone_id = filter.zone_id;
  }

  if (
    filter.zone_id === "All" &&
    Array.isArray(filter.zone_ids) &&
    filter.zone_ids.length > 0
  ) {
    payload.zone_ids = filter.zone_ids;
  }

  return axiosInstance.post(
    EndPoints.Franchise.STATISTICS_MARKETING_PERSONS,
    payload
  );
};
